import BlogSlider from "@/components/common/BlogSlider";
import Hero from "@/components/data-solution/common/Hero";
import { WhyChooseOurServices } from "@/components/data-solution/common/WhyChooseOurServices";
import MobileAppTab from "@/components/data-solution/mobile-app-scraping-services/MobileAppTab";
import Testimonials from "@/components/data-solution/Testimonials";
import Layout from "@/components/layout/Layout";
import { cmsUrl } from "@/utils/helper";
import axios from "axios";
import { OUR_SOLUTION_CARD_MOBILE_DATA } from "const/data-solution";
// const CaseStudyCarousel = dynamic(() =>
//   import('@/components/data-solution/CaseStudyCarousel')
// );

const WebAndMobileAppScraping = ({ data }) => (
  <Layout
    canonicalLink="https://ultroneous.com/mobile-app-scraping-services"
    description="Transform your app data into actionable intelligence with ultroNeous. Best app scraping services for IOS and Android, fueling innovation and strategic growth."
    title="Mobile App Scraping Services for IOS and Android - ultroNeous"
  >
    <Hero
      description="Explore the power of our&nbsp;<b>mobile app scraping services</b>&nbsp;where data comes to life. Uncover invaluable insights for both IOS and Android, shaping your app's success story. Let's turn raw data into meaningful strategies together."
      desktopBackgroundImage="url(/assets/data-solution/herocarouselbg.webp)"
      mainTitle="Mobile App Scraping Services"
      mobileBackgroundImage="url(/assets/data-solution/dataSolutionInnerPage/mobliebg.webp)"
    />
    <WhyChooseOurServices
      subTitle="Why choose our mobile app scraping services"
      subTitleClass="text-white text-center text-4xl md:text-6xl mb-0 pb-10 md:pb-24 md:leading-tight"
      data={OUR_SOLUTION_CARD_MOBILE_DATA}
      buttonName="Get Free Sample Data"
      id="DataScraping-enterprise"
    />
    <MobileAppTab />
    {/* <CaseStudyCarousel /> */}
    <Testimonials link="#DataScraping-enterprise" />
    <div className="py-20 md:py-24">
      {data.blog.length > 0 ? <BlogSlider list={data.blog} /> : <></>}
    </div>
  </Layout>
);

export async function getServerSideProps() {
  let blogData;
  try {
    blogData = await axios
      .get(`${cmsUrl}/wp-json/wp/v2/posts?categories=1`)
      .then((getblog) => getblog);
  } catch (error) {
    blogData = { data: [] };
  }

  return {
    props: {
      data: {
        blog: blogData ? blogData?.data : [],
      },
    },
  };
}

export default WebAndMobileAppScraping;
